import React from "react";
import moment from "moment";
import { Col, Row } from "antd";
import CardHeader from "../../../components/atoms/cardHeader";

export const OverView = ({ overview }) => {
  const BloodSampleDiagnostics = overview?.orderItem?.some(
    (item) => item.productDomainCategory?.en === "Blood & Sample Diagnostics",
  );
  return (
    <>
      {/*General Information Start*/}
      <div className="card card-custom mb-5">
        <CardHeader name={"General Information"} />

        <div className="border border-1 border-light-dark border-top-0 card-body font-weight-bolder p-2">
          <div className="table-responsive">
            <table className="table table-borderless">
              <tbody>
                <tr className="greyBackground">
                  <td className="" style={{ width: "20%" }}>
                    Order Date
                  </td>
                  <td className="" style={{ width: "30%" }}>
                    <span className="text-muted">
                      {moment
                        .utc(overview?.purchasedDate)
                        .local()
                        .format("DD-MM-YYYY hh:mm A")}
                    </span>
                  </td>
                  <td className="" style={{ width: "20%" }}>
                    Customer Name
                  </td>
                  <td className="" style={{ width: "30%" }}>
                    <span className="text-muted">
                      {overview?.customerName?.en}
                    </span>
                  </td>
                </tr>
                <tr className="greyBackground">
                  <td className="">Customer ID</td>
                  <td className="">
                    <span className="text-muted">{overview?.customerId}</span>
                  </td>
                  <td className="">Email</td>
                  <td className="">
                    <span className="text-muted">
                      {overview?.email
                        ? (() => {
                            const [name, domain] = overview.email.split("@");
                            return `${name.slice(0, 2)}******${name.slice(-2)}@${domain}`;
                          })()
                        : ""}
                    </span>
                  </td>
                </tr>
                <tr className="greyBackground">
                  <td className="">Pickup Location/Store</td>
                  <td className="">
                    <span className="text-muted">
                      {overview?.storeLocation?.en}
                    </span>
                  </td>
                  <td className="">Phone</td>
                  <td>
                    <span className="text-muted">
                      {BloodSampleDiagnostics
                        ? overview?.phoneNumber
                          ? `${overview.phoneNumber}`
                          : ""
                        :      overview?.phoneNumber
                        ? `${overview.phoneNumber.slice(0, 2)}******${overview.phoneNumber.slice(-2)}`
                        : ""
                      }
                    </span>
                  </td>
                </tr>
                <tr className="greyBackground">
                  <td className="">Payment Method</td>
                  <td className="">
                    <span className="text-muted">
                      {overview?.paymentMethod}{" "}
                      {overview?.isPreBooked ? "(Pre-Booked)" : ""}
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      {/*General Information End*/}

      {/*Order Items Start*/}
      <div className="card card-custom mb-5">
        <CardHeader name={"Order Items"} />
        <div className="border-1 border-dark border-top-0 card-body p-0">
          <div className="table-responsive">
            <table className="table table-bordered m-0 border radius-remove">
              <thead className="">
                <tr>
                  <th className="align-middle">Items</th>
                  <th className="align-middle">Delivery Option</th>
                  <th className="align-middle">Order Status</th>
                  <th className="align-middle">MRP</th>
                  <th className="align-middle">Quantity</th>
                  <th className="align-middle">Total</th>
                  <th className="align-middle">Selling Price</th>
                </tr>
              </thead>
              <tbody>
                {overview?.orderItem?.map((items, index) => {
                  console.log("productDomainCategory item",items?.productDomainCategory);
                  return (
                    <tr key={index.toString()}>
                      <td className="align-middle">
                        <div className="d-flex align-items-center">
                          <div className="symbol symbol-50 flex-shrink-0 mr-4">
                            <img
                              src={items?.productImageURL}
                              className="w-100"
                              alt=""
                            />
                          </div>
                          <div className="d-flex flex-column font-weight-bold">
                            <span className="">{items?.productName?.en}</span>
                            <span className="text-muted">
                              SKU: {items?.sku}
                            </span>
                          </div>
                        </div>
                      </td>
                      <td className="align-middle">
                        {items?.deliveryOption === "PICK_UP_FROM_VENDOR"
                          ? "PICK UP"
                          : "HOME DELIVERY"}
                      </td>
                      <td className="align-middle">
                        {items?.deliveryOption === "PICK_UP_FROM_VENDOR"
                          ? (items?.orderStage === "PACKED" &&
                              "PICK UP READY") ||
                            (items?.orderStage === "DELIVERED" &&
                              "ITEM COLLECTED") ||
                            items?.orderStage
                          : items?.orderStage}
                        {items?.cancelledReason && (
                          <p>Reason: {items?.cancelledReason}</p>
                        )}
                      </td>
                      <td className="align-middle">Rs. {items?.cost}</td>
                      <td className="align-middle">{items?.quantity}</td>
                      <td className="align-middle">Rs. {items?.total}</td>
                      <td className="align-middle">Rs. {items?.earning}</td>
                    </tr>
                  );
                })}
              </tbody>
              <tfoot>
                <tr>
                  <td
                    className="align-middle text-left text-dark font-weight-bolder text-right"
                    colSpan={6}
                  >
                    Total Bill:
                  </td>
                  <td className="align-middle text-dark font-weight-bold">
                    Rs. {overview?.totalBill}
                  </td>
                </tr>

                 <tr>
                  <td
                    className="align-middle text-left text-dark font-weight-bolder text-right"
                    colSpan={6}
                  >
                    {" "}
                    (Product Tax is already included in the selling price) Tax:
                  </td>
                  <td className="align-middle text-dark font-weight-bold">
                    Rs. {overview?.tax.toFixed(2)}
                  </td>
                </tr>
                <tr>
                  <td
                    className="align-middle text-left text-dark font-weight-bolder text-right"
                    colSpan={6}
                  >
                    Shipment Charges:
                  </td>
                  <td className="align-middle text-dark font-weight-bold">
                    Rs. {overview?.shipmentChargeTotal}
                  </td>
                </tr>

                  <tr>
                  <td
                    className="align-middle text-left text-dark font-weight-bolder text-right"
                    colSpan={6}
                  >
                    Platform Fees:
                  </td>
                  <td className="align-middle text-dark font-weight-bold">
                    Rs.{" "}
                    {overview?.platformFees?.toFixed(2)
                      ? overview?.platformFees.toFixed(2)
                      : 0.0}
                  </td>
                </tr>

                   <tr>
                  <td
                    className="align-middle text-left text-dark font-weight-bolder text-right"
                    colSpan={6}
                  >
                    Discount Coupon Applied:
                  </td>
                  <td className="align-middle text-dark font-weight-bold">
                    Rs. {overview?.discountTotal}
                  </td>
                </tr>

                  <tr>
                  <td
                    className="align-middle text-left text-dark font-weight-bolder text-right"
                    colSpan={6}
                  >
                    {" "}
                    Prepaid Discount:
                  </td>
                  <td className="align-middle text-dark font-weight-bold">
                    Rs. {overview?.prepaidDiscount}
                  </td>
                </tr>

                   <tr>
                  <td
                    className="align-middle text-left text-dark font-weight-bolder text-right"
                    colSpan={6}
                  >
                    Grand Total:
                  </td>
                  <td className="align-middle text-dark font-weight-bold">
                    Rs. {overview?.grandTotal}
                  </td>
                </tr>

                <tr>
                  <td
                    className="align-middle text-left text-dark font-weight-bolder text-right"
                    colSpan={6}
                  >
                    Amount Paid:
                  </td>
                  <td className="align-middle text-dark font-weight-bold">
                    Rs. {overview?.amountPaid}
                  </td>
                </tr>
          
              </tfoot>
            </table>
          </div>
        </div>
      </div>
      {/*Order Items End*/}

      {/*Return Products Start*/}
      {overview?.returnData.length ? (
        <div className="card card-custom mb-5">
          <CardHeader name={"Return Products Request"} />
          <div className="border-1 border-dark border-top-0 card-body p-0">
            <div className="table-responsive">
              <table className="table table-bordered m-0 border radius-remove">
                <thead className="">
                  <tr>
                    <th className="align-middle">Items</th>
                    <th className="align-middle">Delivery Option</th>
                    <th className="align-middle">MRP</th>
                    <th className="align-middle">Quantity</th>
                    <th className="align-middle">Total</th>
                    <th className="align-middle">Earning</th>
                  </tr>
                </thead>
                <tbody>
                  {overview?.returnData?.map((items, index) => {
                    return (
                      <tr key={index.toString()}>
                        <td className="align-middle">
                          <div className="d-flex align-items-center">
                            <div className="symbol symbol-50 flex-shrink-0 mr-4">
                              <img
                                src={items?.productImageURL}
                                className="w-100"
                                alt=""
                              />
                            </div>
                            <div className="d-flex flex-column font-weight-bold">
                              <span className="">{items?.productName?.en}</span>
                              <span className="text-muted">
                                SKU: {items?.sku}
                              </span>
                            </div>
                          </div>
                        </td>
                        <td className="align-middle">
                          {items?.deliveryOption === "PICK_UP_FROM_VENDOR"
                            ? "PICK UP"
                            : "HOME DELIVERY"}
                        </td>
                        <td className="align-middle">Rs. {items?.cost}</td>
                        <td className="align-middle">{items?.quantity}</td>
                        <td className="align-middle">Rs. {items?.total}</td>
                        <td className="align-middle">Rs. {items?.earning}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      ) : (
        ""
      )}
      {/*Return Products End*/}

      {/*Shipping Start*/}
      <Row gutter={[12, 12]}>
        <Col className="gutter-row" xs={24} lg={12}>
          <div className="card card-custom">
            <CardHeader name={"Customer Details"} />
            <div className="card-body p-4 border-1 border-light-dark border border-top-0">
              <div className="font-weight-bold mb-3">
                {overview?.shippingAddress?.fullName}
              </div>
              <div className="text-muted mb-3">
                {(overview?.shippingAddress?.address
                  ? overview?.shippingAddress?.address
                  : "") +
                  ", " +
                  (overview?.shippingAddress?.village?.name
                    ? overview?.shippingAddress?.village?.name
                    : "") +
                  ", " +
                  (overview?.shippingAddress?.tehsil?.name
                    ? overview?.shippingAddress?.tehsil?.name
                    : "") +
                  ", " +
                  (overview?.shippingAddress?.district?.name
                    ? overview?.shippingAddress?.district?.name
                    : "") +
                  ", " +
                  (overview?.shippingAddress?.state?.name
                    ? overview?.shippingAddress?.state?.name
                    : "") +
                  ", " +
                  (overview?.shippingAddress?.country?.name
                    ? overview?.shippingAddress?.country?.name
                    : "") +
                  " , " +
                  (overview?.shippingAddress?.pinCode
                    ? overview?.shippingAddress?.pinCode
                    : "") +
                  " , " +
                  (overview?.shippingAddress?.landMark
                    ? overview?.shippingAddress?.landMark
                    : "")}
              </div>
              <div className="font-weight-bold mb-3"> 
                {BloodSampleDiagnostics}
                Phone number: {} 
                {BloodSampleDiagnostics
                  ? overview?.shippingAddress?.contactNumber
                    ? `${overview?.shippingAddress?.contactNumber}`
                    : ""
                  : overview?.shippingAddress?.contactNumber
                    ? `${overview?.shippingAddress?.contactNumber.slice(0, 2)}******${overview?.shippingAddress?.contactNumber.slice(-2)}`
                    : ""}
              </div>
              <div className="font-weight-bold">
                Email:{" "}
                {overview?.email
                  ? (() => {
                      const [name, domain] = overview?.email.split("@");
                      return `${name.slice(0, 2)}******${name.slice(-2)}@${domain}`;
                    })()
                  : ""}
              </div>
            </div>
          </div>
        </Col>
      </Row>
      {/*Shipping End*/}
    </>
  );
};
